import AuthHelper from 'helpers/auth_helper'
import supportSettings from 'helpers/settings_support'

export const versions = { desktopSearchVersions: { v1: 1, v2: 2 }, jobRateVersions: { v1: 1, v2: 2 } }
const isDev = process.env.NODE_ENV === 'development'

const Settings = {
  getZoomMeetingsEnabled() {
    //return isDev || AuthHelper.is_admin
    return !AuthHelper.logged_in_waitlisted
  },

  chatReceiptMessage: false,
  newCheckoutFlow: true,
  newProjectCreateFlow: true,
  enablePromoCodesForJobs: false,
  jobRateVersion: versions.jobRateVersions.v2, // available only if newProjectCreateFlow is false
  desktopSearchVersion: versions.desktopSearchVersions.v2,
  allowWaitlistedUsersToViewUserProfiles: true,
  enableInitialSignature: isDev,
  newChatVideoLoading: true,
  bookingOffersEnabled: true,
  // signUpAdditionalStepsSkippable: isDev,
  signUpAdditionalStepsSkippable: false,
  // creditCardFeeNumeric: 0.036,
  // clientFee: '5%',
  // clientFeeNumeric: 0.05,
  creditCardFeeNumeric: 0.03,
  creditCardFee: '3%',
  achFeeFlatNumeric: 5,
  achFeeFlat: '$5.00',
  clientFee: '8.75%',
  clientFeeNumeric: 0.0875,
  modelFee: '15%',
  modelFeeNumeric: 0.15,
  minHoursForHourly: 4,
  uaBannerEnabled: true,
  maintenanceMode: process.env.REACT_APP_MAINTENANCE_MODE === 'true',
  appURL: 'https://apps.apple.com/us/app/swipecast/id988583579',
  support: supportSettings,
  offer: { minDayRate: 5, maxDayRate: 10000 },

  SWIPECAST_BACKEND: process.env.REACT_APP_SWIPECAST_BACKEND || 'https://swipecast-backend-staging.herokuapp.com',
  SWIPECAST_IMAGE_BACKEND: process.env.REACT_APP_SWIPECAST_IMAGE_BACKEND,
  STRIPE_PUBLISHABLE_KEY: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,
  LOGGING: process.env.REACT_APP_LOGGING === 'true',
  // ACTIONS_LOGGING: process.env.REACT_APP_ACTIONS_LOGGING === 'true',
  ACTIONS_LOGGING: isDev,
  SWIPECAST_PUSHER_APP_KEY: process.env.REACT_APP_SWIPECAST_PUSHER_APP_KEY || 'e7c5a3f1cd506431cf9f',
  SWIPECAST_PUSHER_APP_CLUSTER: process.env.REACT_APP_SWIPECAST_PUSHER_APP_CLUSTER || 'us2',
  SWIPECAST_ADMIN_URL: process.env.REACT_APP_ADMIN_URL || 'http://localhost:3002',
  GOOGLE_OAUTH_CLIENT_ID: process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID,
  INSTA_APP_ID: process.env.REACT_APP_INSTAGRAM_APP_ID,
}

export default Settings
